import clx from 'classnames';
import styles from './index.module.scss';

interface CommonLoadingProps {
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
  backgroundColor?: string;
}

export const CommonLoading: React.FC<CommonLoadingProps> = ({
  loading,
  children,
  className,
  backgroundColor,
}) => {
  return (
    <div
      className={clx(styles.container, className, {
        [styles.noContent]: !children && loading,
      })}
      style={
        backgroundColor
          ? ({ '--overlay-background': backgroundColor } as React.CSSProperties)
          : undefined
      }
    >
      {loading && (
        <div className={styles.overlay}>
          <div className={styles.loading} />
        </div>
      )}
      {children}
    </div>
  );
};
